"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesContext = void 0;
const react_1 = require("react");
exports.FilesContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=files-context.js.map